const Products = [
    {
        id: 1,
        name: 'Hydrochloric Acid',
        slug: 'hydrochloric-acid',
        image: '/images/products/hydrochloric-acid/hydrochloric-acid.png',
        description: 'Industrial Grade Chemical for metal treatment and pH control'
    },
    {
        id: 2,
        name: 'Activated Carbon',
        slug: 'activated-carbon',
        image: '/images/products/activated-carbon/activated-carbon.jpg',
        description: 'High-Performance Adsorbent Material for water and air purification'
    },
    {
        id: 3,
        name: 'Hydrated Lime',
        slug: 'hydrated-lime',
        image: '/images/products/hydrated-lime/hydrated-lime.jpg',
        description: 'Calcium Hydroxide for construction and water treatment'
    },
    {
        id: 4,
        name: 'Quick Lime',
        slug: 'quick-lime',
        image: '/images/products/quick-lime/quick-lime.jpg',
        description: 'Calcium Oxide for steel manufacturing and industrial processes'
    },
    {
        id: 5,
        name: 'Dolomite',
        slug: 'dolomite',
        image: '/images/products/dolomite/dolomite.jpg',
        description: 'Calcium Magnesium Carbonate for construction and agriculture'
    },
    {
        id: 6,
        name: 'Di Methyl Sulphate',
        slug: 'dimethyl-sulphate',
        image: '/images/products/dimethyl-sulphate/dimethyl-sulphate.jpg',
        description: 'Methylating agent for pharmaceutical and chemical synthesis'
    },
    {
        id: 7,
        name: 'Sodium Aluminate',
        slug: 'sodium-aluminate',
        image: '/images/products/sodium-aluminate/sodium-aluminate.jpg',
        description: 'Solution and powder form for water treatment and paper industry'
    },
    {
        id: 8,
        name: '3,3 DI Nitro Di Phenyl Sulphone',
        slug: 'dinitro-diphenyl-sulphone',
        image: '/images/products/dinitro-diphenyl-sulphone/dinitro-diphenyl-sulphone.jpg',
        description: 'Specialty chemical for high-performance polymer synthesis'
    }
];

export default Products;
